import { render, staticRenderFns } from "./UserGroupsDetails.vue?vue&type=template&id=5f228c77&"
import script from "./UserGroupsDetails.vue?vue&type=script&lang=js&"
export * from "./UserGroupsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports